// TODO convert to enum
export const payMethodEnum = {
  APPLE_PAY: 'payu-jp',
  GOOGLE_PAY: 'payu-ap',
}
